export class UserInfoErrorMessageModel {

    /** お名前のエラーメッセージ */
    nameErrorMsg: string = "";
    /** お名前（かな）のエラーメッセージ */
    kanaErrorMsg: string = "";
    /** 性別のエラーメッセージ */
    genderErrorMsg: string = "";
    /** 生年月日のエラーメッセージ */
    birthdayErrorMsg: string = "";
    /** 電話番号のエラーメッセージ */
    telErrorMsg: string = "";
    /** 郵便番号のエラーメッセージ */
    postalCodeErrorMsg: string = "";
    /** 都道府県のエラーメッセージ */
    prefectureErrorMsg: string = "";

    public reset() {
        // メッセージを初期化
        this.nameErrorMsg = "";
        this.kanaErrorMsg = "";
        this.genderErrorMsg = "";
        this.birthdayErrorMsg = "";
        this.telErrorMsg = "";
        this.postalCodeErrorMsg = "";
        this.prefectureErrorMsg = "";
    }
}